/**
 * Fetch images another page will need before the user navigates to it.
 *
 * Moving between pages is client-side routing, so the destination's static
 * HTML (and the <link rel="preload"> tags scripts/*-postbuild.js put in it)
 * never loads. Without this, a hero image is only discovered once the new
 * page renders and pops in a beat late. An off-DOM <img> with the page's own
 * srcset and sizes makes the browser pick and cache the exact candidate the
 * page will then request.
 *
 * Runs when the browser is idle and skips users who asked to save data.
 */
export default function warmImages(list) {
  if (typeof window === 'undefined') return;
  const connection = navigator.connection;
  if (connection && connection.saveData) return;

  const run = () => {
    for (const image of list) {
      if (!image || !image.src) continue;
      const img = new Image();
      // Order matters: sizes and srcset before src, or the browser may fetch twice.
      if (image.sizes) img.sizes = image.sizes;
      if (image.srcSet) img.srcset = image.srcSet;
      img.src = image.src;
    }
  };
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(run, { timeout: 1500 });
  } else {
    window.setTimeout(run, 300);
  }
}
